import type { JSX } from 'react';

import { Button, Link } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { ICON_CLOSE } from 'Config/Icons';
import { getFrameworkGroupControlURL } from 'Helpers/URLBuilder/URLBuilder';

export interface AssociatedControlGroup {
    controlGroupIdentifier: string; // Canonical identifier for a Control Group. Example: "CIS CSC (v8.0)#1"
    controlGroupName: string;
    isCustom: boolean;
}

export interface AssociatedControlGroupsModalProps {
    hideModal: () => void;
    associatedControlGroups: AssociatedControlGroup[];
    headerText?: { text: string; secondaryText?: string };
}

export const AssociatedControlGroupsModal = (props: AssociatedControlGroupsModalProps): JSX.Element => {
    const sortedControlGroups = (() => {
        if (props.associatedControlGroups.length < 1) {
            return undefined;
        }

        return props.associatedControlGroups.sort((controlGroupA, controlGroupB) => {
            if (controlGroupA.isCustom === true && controlGroupB.isCustom === false) {
                return 1;
            } else if (controlGroupA.isCustom === false && controlGroupB.isCustom === true) {
                return -1;
            } else if (controlGroupA.isCustom === false && controlGroupB.isCustom === false) {
                return controlGroupA.controlGroupIdentifier.localeCompare(controlGroupB.controlGroupIdentifier, undefined, { numeric: true, sensitivity: 'base' });
            } else {
                if (controlGroupA.controlGroupName && controlGroupB.controlGroupName) {
                    return controlGroupA.controlGroupName.localeCompare(controlGroupB.controlGroupName, undefined, { numeric: true, sensitivity: 'base' });
                } else if (controlGroupA.controlGroupName && !controlGroupB.controlGroupName) {
                    return 1;
                } else if (!controlGroupA.controlGroupName && controlGroupB.controlGroupName) {
                    return -1;
                } else {
                    return 0;
                }
            }
        });
    })();

    return (
        <Modal open header={props.headerText?.text ?? 'Control Groups'} subHeader={props.headerText?.secondaryText}>
            {sortedControlGroups?.map((controlGroup) => {
                return (
                    <Link to={getFrameworkGroupControlURL(controlGroup.controlGroupIdentifier)} size="sm" key={controlGroup.controlGroupIdentifier} openInNewTab>
                        {controlGroup.controlGroupName}
                    </Link>
                );
            })}
            <div className={'modalFormButtonContainer'}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
